import { getInitialState, getPath } from "../../utils";

const initialState = {
  fleetCoachList: [],
  currentPage: 1,
  nextPage: 2,
  prevPage: -1,
  activeFilters: {},
  activeFleetCoach: {},
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_FLEET_COACH_LIST":
      return setFleetCoachList(state, action);
    case "SET_FLEET_COACH_ACTIVE_OBJECT":
      return setFleetCoachActiveObject(state, action);
    case "SET_FLEET_COACH_ACTIVE_FILTERS":
      return setFleetCoachActiveFilters(state, action);
    case "SET_FLEET_COACH_CURRENT_PAGE":
      return setFleetCoachCurrentPage(state, action);
    default:
      return state;
  }
}

const setFleetCoachList = (state, action) => {
  return {
    ...state,
    fleetCoachList: getPath(action.payload, "fleetCoaches", []),
    prevPage: getPath(action.payload, "page_response.previous_page", []),
    nextPage: getPath(action.payload, "page_response.next_page", []),
  };
};

const setFleetCoachActiveObject = (state, action) => {
  return {
    ...state,
    activeFleetCoach: action.payload,
  };
};

const setFleetCoachActiveFilters = (state, action) => {
  return {
    ...state,
    activeFilters: action.payload,
  };
};
const setFleetCoachCurrentPage = (state, action) => {
  return {
    ...state,
    currentPage: action.payload,
  };
};
